let tasks: { [name: string]: Task; } = {};

interface Task {
    (payload: TaskPayload): void;
}

export interface TaskPayload {
    identifier: string;
    state: number;
}

/**
 * ProgressTask can register here with a callback so it get called with dispatch
 */
export function register(name: string, taskCallback: Task): void {
    tasks[name] = taskCallback;
}

/**
 * ProgressTask can unregister himself with the id he is saved in the array
 */
export function unregister(name: string) {
    delete tasks[name];
}

/**
 * Dispatch calls every registered callback and give these the payload.
 * The payload should always have the identifier for the ProgressTask and the state the
 * ProgressTask should switch to
 *
 */
export function dispatch(payload: TaskPayload) {
    Object.keys(tasks).forEach(key =>  {
        if (!tasks[key]) {
            console.error(`${key} not found in registered tasks, or removed`);
        } else {
            tasks[key](payload);
        }
    });
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/progress-dialog/ProgressDialogDispatcher.ts
 **/